import { render } from "./AppLoader.vue?vue&type=template&id=7b8b04cc&scoped=true"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"

import "@/Common/Styles/appLoader.scss?vue&type=style&index=0&id=7b8b04cc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8b04cc"]])

export default __exports__